import { memo } from "react";

import { Typo } from "../../Typo";
import {
  changeColors,
  dynamicChange,
  getSign,
} from "../../utils/headlineMetrics";
import { LeadInfoInfoDashboardTooltip } from "./LeadInfoInfoDashboardTooltip";

type LeadsInfoCardProps = {
  title: string;
  value: number;
  changeInPercent: number;
  change: string;
  tooltipLabel?: string;
  onHover?: () => void;
  isMobile?: boolean;
};

export const LeadsInfoCard = memo(
  ({
    title,
    value,
    changeInPercent,
    change,
    tooltipLabel,
    isMobile = false,
    onHover,
  }: LeadsInfoCardProps) => {
    return (
      <div className="flex w-full flex-col rounded-xl bg-surface-base-brand px-6 py-4 md:py-6">
        <Typo
          element="span"
          type="labelMD"
          textColor="text-text-base-secondary"
          classes="flex items-center gap-2 mb-2"
        >
          {title}
          {tooltipLabel && (
            <LeadInfoInfoDashboardTooltip
              title={title}
              tooltipText={tooltipLabel}
              isMobile={isMobile}
              onHover={onHover}
            />
          )}
        </Typo>
        <Typo
          element="h2"
          type="heading4XL"
          textColor="text-text-base-primary"
          classes="mb-4"
        >
          {value}
        </Typo>
        <div className="flex items-center gap-2 text-text-base-secondary">
          <Typo
            element="span"
            type="bodyXS"
            textColor={`${changeColors[dynamicChange(changeInPercent)]}`}
            classes={`rounded-lg p-1 ${changeColors[dynamicChange(changeInPercent)]}`}
          >
            {getSign(changeInPercent)}
            {changeInPercent}%
          </Typo>
          <Typo
            element="span"
            type="bodyXS"
            textColor="text-text-base-secondary"
          >
            {change}
          </Typo>
        </div>
      </div>
    );
  },
);
